import { useCallback, useEffect, useRef, useState } from 'react';

export const useMountedSafeState = initialState => {
  const isMountedRef = useRef(false);
  const [state, setState] = useState(initialState);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const setMountedSafeState = useCallback(nextState => {
    if (!isMountedRef.current) return;

    setState(nextState);
  }, []);

  return [state, setMountedSafeState];
};
